function RapaNui({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1948)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FCFCFC"/>
  <path d="M20.8695 13.2168V14.6081H22.779C21.9822 15.7156 20.9207 16.6197 19.6875 17.2285C19.3711 16.8999 18.9269 16.695 18.4347 16.695C17.605 16.695 16.9115 17.2762 16.7379 18.0537C16.4947 18.075 16.2487 18.0864 16 18.0864C15.7513 18.0864 15.5052 18.0749 15.2621 18.0537C15.0884 17.2763 14.3949 16.695 13.5652 16.695C13.073 16.695 12.629 16.8999 12.3125 17.2285C11.0792 16.6198 10.0179 15.7155 9.22099 14.6081H11.1304V13.2168H6.26086C6.26086 18.5955 10.6213 22.9559 16 22.9559C21.3788 22.9559 25.7391 18.5955 25.7391 13.2168H20.8695Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default RapaNui;
